export const CURRENCY_LOCALSTORAGE_KEY = 'Curr'
export const BBDSALE_DATERANGE = [new Date('10/03/2021'), new Date('10/10/2021')]

export const BADGE_TYPE = {
    TUPLE_BANNER: 'TUPLE_BANNER'
}

export const CODE_TYPE = {
    COUPON: 'COUPON',
    GIFT_VOUCHER: 'GIFT_VOUCHER'
}

export const GIFT_VOUCHER_PATTERN =
    process.env.CT_ENV === 'production'
        ? ['100137','110009', '112006', '300013', '300033', '600137']
        : ['100137','110009', '112006', '300013', '300033', '100147', '500400']

export const COUPON_GV_INPUT_REGEX = /^[A-Za-z0-9]{0,16}$/
export const ONLY_NUMBER_REGEX = /^[0-9]+$|^$/
export const ERROR_MSG = {
    FAILURE: 'Something went wrong. Please try again.',
    INVALID_CARD: 'Invalid card number',
    INVALID_CARD_AND_PIN: 'Invalid gift card or pin',
    INVALID_CARD_PIN: 'Invalid card pin',
    GV_ALREADY_APPLIED: 'You�ve already entered that gift card.'
}
export const CURRENCY_CODE = 'BHD'
export const RATE = '1'
export const SELLING_RATE = '1'
export const MAX_GV_COUNT = 15
export const MAX_GV_TEXT = `Only ${MAX_GV_COUNT} gift cards can be applied`
export const PAGE_NAME = {
    HOME: 'hotels_home',
    RESULT: 'hotels_srp',
    DETAIL: 'hotels_details',
    ITINERARY: 'hotels_itinerary',
    ITINERARY_SUPERCOIN: 'hotels_itinerary_supercoin'
}

export const LOGIN_ENTRY_POINT = {
    ITINERARY_SUPERCOIN: 'hotels_itinerary_supercoin_login',
    ITINERARY_NAV_BAR: 'hotels_itinerary_nav_bar_login',
    ITINERARY_CONTACT: 'hotels_itineray_contact_login'
}

export const ERROR_MESSAGE = {
    FIRST_NAME: 'Please enter valid first name',
    LAST_NAME: 'Please enter valid last name',
    TITLE: 'Please choose a title',
    INVALID_PAN_MSG: 'Please enter correct PAN card number',
    EMPTY_PAN_MSG: 'PAN card number is required',
    NUMBER: 'Please enter a valid phone number',
    EMAIL_ID: 'Please enter a valid email address',
    PAN_CARD: 'Please enter correct PAN card number',
    DEFAULT: 'Please enter valid details'
}

export const FEATURE_KEY = {
    SCROLLABLE_ITINERARY: 'h_exp16'
}

export const LOGIN_BANNER_URL =
    'https://fastui.cltp.co/image/upload/f_auto,q_auto,w_410,h_437,dpr_2/me-offermgmt/offermgmt/bbdJson/Desktop_Banner.png'
